import React from "react";
import * as ReactTabs from "react-tabs";
import { useTranslation } from "react-i18next";
import { useRestaurant } from "../../../utils/contexts/restaurant-context";
import BeveragesContent from "./BeveragesContent";
import Course from "../../menu/Course";
import PreferredList from "../../list/Preferred";
import PreferredMenu from "../../menu/Preferred";
import ReviewsTab from "../ReviewsTab";
import Row from "../../list/Row";
import TabsButton from "./TabsButton";
import categoriesBuilder from "../../../utils/categoriesBuilder";

export default function TabsTermeChianciano(props) {
    const { hasOrders } = props;

    const { restaurant } = useRestaurant();
    const { t } = useTranslation();

    const [isSearching, setIsSearching] = React.useState(false);
    const [result, setResult] = React.useState([]);
    const [activeTab, setActiveTab] = React.useState(1);

    return (
        <ReactTabs.Tabs selectedIndex={activeTab} onSelect={setActiveTab}>
            <ReactTabs.TabList>
                <div className="tabs relative">
                    <div className="bar overflow-x-scroll flex mx-3 py-3">
                        <ReactTabs.Tab key="course">
                            <TabsButton
                                tabText={restaurant.tabs[0]}
                                isActive={activeTab === 0}>
                            </TabsButton>
                        </ReactTabs.Tab>

                        <ReactTabs.Tab key="beverage">
                            <TabsButton
                                tabText={restaurant.tabs[1]}
                                isActive={activeTab === 1}>
                            </TabsButton>
                        </ReactTabs.Tab>

                        <ReactTabs.Tab key="indecisi">
                            <TabsButton
                                tabText={t("tab.button_3")}
                                isActive={activeTab === 2}>
                            </TabsButton>
                        </ReactTabs.Tab>

                        <ReactTabs.Tab key="reviews">
                            <TabsButton
                                tabText={t("tab.button_rate_place")}
                                isActive={activeTab === 3}>
                            </TabsButton>
                        </ReactTabs.Tab>
                    </div>
                </div>
            </ReactTabs.TabList>

            <ReactTabs.TabPanel key="panel-courses">
                {categoriesBuilder.buildCategoriesTree(restaurant.courses).map((course, index) =>
                    hasOrders ?
                        <Row course={course} index={index} key={`course-${index}`}></Row> :
                        <Course course={course} index={index} key={`course-${index}`}></Course>
                )}
            </ReactTabs.TabPanel>

            <ReactTabs.TabPanel key="panel-beverages">
                <BeveragesContent
                    beverages={restaurant.beverages}
                    isSearching={isSearching}
                    result={result}
                    hasOrders={hasOrders}
                    setResult={setResult}
                    setIsSearching={setIsSearching}>
                </BeveragesContent>
            </ReactTabs.TabPanel>

            <ReactTabs.TabPanel key="panel-preferred">
                {hasOrders ?
                    <PreferredList></PreferredList> :
                    <PreferredMenu></PreferredMenu>}
            </ReactTabs.TabPanel>

            <ReactTabs.TabPanel key="panel-reviews">
                <ReviewsTab></ReviewsTab>
            </ReactTabs.TabPanel>
        </ReactTabs.Tabs>
    );
}
